import React from "react";
import { Box, Stack } from "@mui/material";
import { PositionBehaviour } from "../../../store/slices/strategySlice";
import { useTheme } from "@mui/material/styles";
import Header from "../../../_modules/Header/Header";
import PageLayout from "../../../_components/PageLayout";
import CustomPaper from "../../../_components/CustomPaper";
import AdronTypography from "../../../_components/AdronTypography";
import SwitchField from "../../../_components/SwitchField";
import IconComponent from "../../../_components/IconComponent";

interface Props {
  onClose: (value: boolean) => void;
  value: PositionBehaviour;
  onChange: (value: PositionBehaviour) => void;
}

const AdvancedSettingsStrategy = ({ onClose, value, onChange }: Props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
        background:
          theme.palette.mode === "dark" ? "rgba(13, 16, 18, 1)" : "rgba(245, 245, 245, 1)",
      }}
    >
      <PageLayout
        header={<Header pageTitle={"Advanced settings"} needBack onChange={onClose} />}
        contentSx={{ padding: "20px 8px 0" }}
      >
        <CustomPaper color={theme.palette.grey[500]}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            spacing={"3px"}
            sx={{ marginBottom: "5px" }}
          >
            <AdronTypography value="Position behaivour" halfOpacity />
          </Stack>
          <Stack direction={"column"} spacing={3}>
            <SwitchField
              value={value}
              onChange={onChange}
              paramList={[
                {
                  value: "Reduce",
                  label: "Reduce",
                  icon: <IconComponent iconName={"MinusQuare"} hasStroke hasFill />,
                },
                { value: "Both", label: "Both", icon: undefined },
                {
                  value: "Accumulate",
                  label: "Accum.",
                  icon: <IconComponent iconName={"PlusQuare"} hasStroke hasFill />,
                },
              ]}
            />
            <Stack direction={"column"} spacing={1} alignItems={"flex-start"}>
              {value === "Reduce" && (
                <AdronTypography
                  value={
                    "The auto strategy will focus on reducing positions, prioritizing profit-taking and minimizing exposure. This setting is ideal for strategies that aim to lock in gains and mitigate risks in volatile markets."
                  }
                  halfOpacity
                />
              )}
              {value === "Both" && (
                <AdronTypography
                  value={
                    "The auto strategy will manage positions flexibly, allowing it to both reduce and accumulate positions based on market conditions. This default setting ensures adaptability, balancing profit-taking and position growth strategies for optimized performance."
                  }
                  halfOpacity
                />
              )}
              {value === "Accumulate" && (
                <AdronTypography
                  value={
                    "The auto strategy will concentrate on accumulating positions, increasing the size of holdings when conditions are favorable. This setting is suited for strategies focused on long-term growth or building positions during favorable trends."
                  }
                  halfOpacity
                />
              )}
            </Stack>
          </Stack>
        </CustomPaper>
      </PageLayout>
    </Box>
  );
};

export default AdvancedSettingsStrategy;
